module.exports = __webpack_public_path__ + "assets/dienst5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/documentation/images/dienst5.jpg
// module id = 361
// module chunks = 0